// @flow
import { EventosActionTypes } from './constants';

type EventosAction = { type: string, payload: {} | string };

// common success
export const eventosApiResponseSuccess = (actionType: string, data: any): EventosAction => ({
    type: EventosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const eventosApiResponseError = (actionType: string, error: string): EventosAction => ({
    type: EventosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getEvento = (id: string): EventosAction => ({
    type: EventosActionTypes.GET_EVENTO,
    payload: { id },
});

export const addEvento = (evento:any):EventosAction=>({
    type:EventosActionTypes.ADD_EVENTO,
    payload:evento
})
export const updateEvento = (evento:any):EventosAction=>({
    type:EventosActionTypes.UPDATE_EVENTO,
    payload:evento
})
export const deleteEvento = (id:string):EventosAction=>({
    type:EventosActionTypes.DELETE_EVENTO,
    payload:{id}
})

export const listEventos = (params:any): EventosAction => ({
    type: EventosActionTypes.LIST_EVENTOS,
    payload: params,
});

export const setFiltersEventos = (params:any): EventosAction => ({
    type: EventosActionTypes.SET_FILTER,
    payload: params,
})

export const resetEventos = (): EventosAction => ({
    type: EventosActionTypes.RESET,
    payload: {},
});

